export default __webpack_public_path__ + "static/media/slider_horizontal_theme1.16f98f4b.svg";